import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AgentService } from './agent.service';
import { IChatAdapter, IChatMessage, IThread, IAgentResponse } from '../interfaces';

/**
 * Foundry Agent adapter - wraps existing AgentService
 * Maintains current Foundry Agent implementation
 */
@Injectable({
	providedIn: 'root'
})
export class FoundryAgentAdapter implements IChatAdapter {
	constructor(private _agentService: AgentService) {}

	getThreads(): Observable<IThread[]> {
		return this._agentService.getThreads();
	}

	createThread(): Observable<IThread> {
		return this._agentService.createThread();
	}

	getMessages(threadId: string): Observable<IChatMessage[]> {
		return this._agentService.getMessages(threadId);
	}

	sendMessage(threadId: string, content: string): Observable<IAgentResponse> {
		return this._agentService.sendMessage(threadId, content);
	}
}
